import { render, staticRenderFns } from "./LoanTemplateSelector.vue?vue&type=template&id=cf52f252"
import script from "./LoanTemplateSelector.vue?vue&type=script&lang=js"
export * from "./LoanTemplateSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports